import { render } from "./SabyIntegrationCard.vue?vue&type=template&id=693985e9&scoped=true"
import script from "./SabyIntegrationCard.vue?vue&type=script&lang=js"
export * from "./SabyIntegrationCard.vue?vue&type=script&lang=js"

import "./SabyIntegrationCard.vue?vue&type=style&index=0&id=693985e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693985e9"]])

export default __exports__